import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class SsrBaggageService {

  private buildResult(): any[] {
    const t = localStorage.getItem('trip_type__'),
          s: any[] = JSON.parse(localStorage.getItem('_Flight_Detials') || '[]');
    if (!Array.isArray(s)) return [];
    switch (t) {
      case 'roundTrip':
        return s.map((i: any) => ({
          name: i.name,
          title: i.title,
          type: 'roundTrip',
          flights: i.list.flatMap((l: any) =>
            l.flightlegs.flat().map((f: any) =>
              [f.carrier, f.flightnumber, f.origin, f.destination].join('-')))
        }));
      case 'oneWayTrip':
        return [{
          type: 'oneWayTrip',
          flights: s.flatMap((i: any) =>
            i.list.flatMap((l: any) =>
              l.infoFlight.flightlegs.flat().map((f: any) =>
                [f.carrier, f.flightnumber, f.origin, f.destination].join('-'))))
        }];
      case 'round_international':
        return s.flatMap((i: any) =>
          i.list.flatMap((l: any) => {
            const g = (x: any[]) => x.map((f: any) =>
              [f.carrier, f.flightnumber, f.origin, f.destination].join('-'));
            const [o, inb] = l.infoFlight?.flightlegs || [];
            return [o, inb]
              .map((fl: any, k: number) => fl?.length ? { flights: g(fl), type: 'round_international' } : null)
              .filter(Boolean);
          }));
      default:
        return [];
    }
  }

  toggleValue(i: any, li: any, L: any[]) {
    const R = this.buildResult(),
          P = L.find(p => p.SSR__?.some((s: any) => s.listValue?.some((x: any) => x.value.includes(i)))),
          M = P && R.find((r: any) => r.flights?.includes(i?.ssr_name));
    if (!P || !M) return L;
    const S = P.SSR__?.some((s: any) =>
      M.flights.includes(s.name) &&
      s.listValue?.some((x: any) =>
        x.value?.some((v: any) => v.fee_code === i?.fee_code && v.ssr_value === 1)
      )
    );
    const F = (val: number) => P.SSR__?.forEach((s: any) =>
      M.flights.includes(s.name) &&
      s.listValue?.forEach((x: any) =>
        x.name === "Baggage" &&
        x.value?.forEach((v: any) =>
          v.fee_code === i?.fee_code ? v.ssr_value = val : (val && (v.ssr_value = 0))
        )
      )
    );
    i.ssr_value = S ? 0 : 1;
    F(i.ssr_value);
    li.value.forEach((e: any) => e.ssr_value = (e === i ? i.ssr_value : 0));
    return L;
  }
}